const adaptEpcOfferRequestData = data => ({
	...data,
});

export default adaptEpcOfferRequestData;
